import { Figure } from '../../atoms/figure/Figure';
import { Container } from '../../molecules/container/Container';
import { LinkList } from '../../molecules/linkList/LinkList';
import { List } from '../../molecules/list/List';
import { ListItem } from '../../molecules/listItem/ListItem';
import { ListItemLink } from '../../molecules/listItemLink/ListItemLink';
import { PageSection } from '../../molecules/pageSection/PageSection';

export function Footer() {
    return (
        <div className="footer">
            <Container isFluidOnMobile>
                <PageSection>
                    <div className="row justify-content-between">
                        <LinkList theme="white">
                            <ListItemLink to="/contact">Hulp & contact</ListItemLink>
                            <ListItemLink to="/overksyos">Over Ksyos</ListItemLink>
                        </LinkList>
                        <div className="kiwa-logos">
                            <Figure
                                alt="kiwa logo ISO"
                                className="kiwa-logo"
                                imageUrl="/assets/images/kiwa-logo-1.png"
                            />
                            <Figure
                                alt="kiwa logo NEN"
                                className="kiwa-logo"
                                imageUrl="/assets/images/kiwa-logo-2.png"
                            />
                        </div>
                    </div>
                    <div className="row justify-content-end">
                        <List
                            listStyle="none"
                            textAlign="right"
                            theme="white"
                        >
                            <ListItem>© Ksyos 2019</ListItem>
                            <ListItem>Kvk: 34 16 61 85</ListItem>
                        </List>
                    </div>

                    <div className="row">
                        <LinkList
                            inline
                            theme="white"
                        >
                            <ListItemLink
                                onClick={() =>
                                    window.open('https://ksyos.nl/privacy-informatiebeveiliging', '_blank', 'noopener')
                                }
                                to="https://ksyos.nl/privacy-informatiebeveiliging"
                            >
                                Privacy
                            </ListItemLink>
                            <ListItemLink to="/toegankelijkheid">Toegankelijkheid</ListItemLink>
                            <ListItemLink to="/cookies">Cookies</ListItemLink>
                        </LinkList>
                    </div>
                </PageSection>
            </Container>
        </div>
    );
}
